import { IOrderComposition } from "../../../../../modules/cart/domain/models/IOrderComposition";
import { IOrderCompositionItem } from "../../../../../modules/cart/domain/models/IOrderCompositionItem";
import { PrincingTypeEnum } from "../../../../../modules/catalog/domain/models/PrincingTypeEnum";


export const CalcTotalsAllCompositions = (prevCompositions: IOrderComposition[]): { quantity: number, price: number } => {

    const calcTotalsAllCompositions = (_prevCompositions: IOrderComposition[]) => {
        //const price = _prevCompositions
        //    .flatMap((_composition) => _composition.compositionItems)
        //    .map(_item => (_item.totalPrice))
        //    .reduce((previousValue, currentValue) => previousValue + currentValue, 0);

        const quantity = _prevCompositions
            .flatMap((_composition) => _composition.compositionItems)
            .map(_item => (_item.quantity))
            .reduce((previousValue, currentValue) => previousValue + currentValue, 0);


        const price = _prevCompositions.map(composition => {
            if (composition.pricingType === PrincingTypeEnum.MAX) {
                if(!composition.compositionItems.length){
                    return 0;
                }
                let compositionMaxPrice: IOrderCompositionItem = composition.compositionItems[0];
                composition.compositionItems.forEach(item => {
                    if (!compositionMaxPrice){
                        compositionMaxPrice = item;
                    } else if(item.price > compositionMaxPrice.price){
                        compositionMaxPrice = item;
                    } 
                })
                
                return compositionMaxPrice?.price;
            } else {
                return composition.compositionItems.map(item => item.totalPrice).reduce((previousValue, currentValue) => previousValue + currentValue, 0)
            }

        }).reduce((previousValue, currentValue) => previousValue + currentValue, 0);
        return { quantity, price }
    }

    return calcTotalsAllCompositions(prevCompositions)

}
